import { Component, OnDestroy, OnInit } from '@angular/core';

import { BaseCtrlValueAccessorFormComponent } from '@sim/form';

import { PRD } from '@atmi/core/models';

@Component({
  selector: 'app-prd-form',
  styleUrls: ['./prd-form.component.scss'],
  templateUrl: './prd-form.component.html',
})
export class PrdFormComponent extends BaseCtrlValueAccessorFormComponent<PRD> implements OnDestroy, OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
